"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StudyCaptureStatusType = void 0;
var StudyCaptureStatusType;
(function (StudyCaptureStatusType) {
    StudyCaptureStatusType["Disable"] = "DISABLE";
    StudyCaptureStatusType["Enable"] = "ENABLE";
})(StudyCaptureStatusType = exports.StudyCaptureStatusType || (exports.StudyCaptureStatusType = {}));
//# sourceMappingURL=studyCaptureCrfStatusByTrigger.js.map